export default "__VITE_ASSET__CEW34oOe__"